import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout, theme, Row, Col, Modal, Divider, Tag} from 'antd';
import ResponsiveNav from './Components/ResponsiveNav/Index';

import google from './Images/google.png';
import apple from './Images/apple.png';
import CommonFooter from './Components/CommonFooter';
import CommonContextProvider from './Context';

import english from './Translations/English.json';
import hindi from './Translations/Hindi.json';
import malayalam from './Translations/Malayalam.json';

const { Header, Content } = Layout;

const App = () => {
    const [openConfirmLogout, setOpenConfirmLogout] = useState(false);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;   

    const {
        token: { colorBgContainer },
    } = theme.useToken();


    const confirmLogout = () => {
        setOpenConfirmLogout(false);
    };

    const cancelLogout = () => {
        setOpenConfirmLogout(false);
    };

    return (
        <>
            <CommonContextProvider>
                <Layout
                    style={{
                        minHeight: '100vh',
                    }}
                >
                    {/* LHS Starts */}
                    {/* <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <div className="demo-logo-vertical" style={{ paddingTop: '20px', paddingBottom: '20px', textAlign: 'center'}}>
          <img src="https://tlp.tranzmeo.com/2695ac035fd127bf710093612bf6bbd8.png" width="120px"/>
        </div>
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" items={items} />
      </Sider> */}
                    {/* LHS Ends */}
                    <Layout>
                        {/* Header Starts */}
                        <Header
                            style={{
                                padding: 0,
                                background: colorBgContainer,
                                position : 'relative',
                                zIndex : 2 
                            }}
                        >
                            <ResponsiveNav />
                        </Header>
                        <Content style={{ padding: '0' }}>
                            <div style={{
                                position : 'relative',
                                zIndex : 2 
                            }}>
                                <Row justify="center">
                                    <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }} style={{ background: 'linear-gradient(129.32deg, #546FFB 5.78%, #AD4DF8 98.3%), #C4C4C4' }}>
                                        <Row>
                                            <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 4 }} xl={{ span: 5 }} xxl={{ span: 5 }} style={{ marginTop: '5px' }}>
                                                <div style={{ color: '#fff', fontWeight: 'bold', marginLeft: 20 }}>support@quikdr.com</div>
                                                <div style={{ color: '#fff', marginLeft: 20, marginTop: '8px' }}>{langdata.Emailusat ? langdata.Emailusat : 'Email us at' }</div>
                                            </Col>
                                            <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 1 }} xl={{ span: 1 }} xxl={{ span: 1 }}><Divider style={{ height: '70px', backgroundColor: '#ffffff' }} type="vertical" /></Col>
                                            <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 5 }} xl={{ span: 5 }} xxl={{ span: 5 }} style={{ marginTop: '5px' }}>
                                                <div style={{ color: '#fff', fontWeight: 'bold', marginLeft: 20 }}>+91-7012030327</div>
                                                <div style={{ color: '#fff', marginLeft: 20, marginTop: '5px' }}>{langdata.Callforcustomersupport ? langdata.Callforcustomersupport : 'Call for customer support'}</div>
                                            </Col>
                                            <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 1 }} xl={{ span: 1 }} xxl={{ span: 1 }}><Divider style={{ height: '70px', backgroundColor: '#ffffff' }} type="vertical" /></Col>
                                            <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 4 }} xl={{ span: 5 }} xxl={{ span: 5 }} style={{ marginTop: '5px' }}>
                                                <div style={{ color: '#fff', fontWeight: 'bold', marginLeft: 20 }}>+91-7012030327</div>
                                                <div style={{ color: '#fff', marginLeft: 20, marginTop: '5px' }}>{langdata.Callforappointment ? langdata.Callforappointment : 'Call for appointment'}</div>
                                            </Col>
                                            <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 1 }} xl={{ span: 1 }} xxl={{ span: 1 }}><Divider style={{ height: '70px', backgroundColor: '#ffffff' }} type="vertical" /></Col>
                                            <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 8 }} xl={{ span: 6 }} xxl={{ span: 6 }} style={{ marginTop: '5px' }}>
                                                <img style={{ marginTop: 'px', height: '50px', cursor: 'pointer' }} onClick={() => {
                                                    window.open('https://apps.apple.com/us/app/id1512292509');
                                                }} src={apple} />
                                                <img style={{ marginTop: 'px', height: '50px', cursor: 'pointer' }} src={google} onClick={() => {
                                                    window.open('https://play.google.com/store/apps/details?id=com.quikdr.app');
                                                }} />

                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col xs={{ span: 0 }} md={{ span: 0 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }} style={{ background: 'linear-gradient(129.32deg, #546FFB 5.78%, #AD4DF8 98.3%), #C4C4C4' }}>
                                        <div style={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>
                                            {langdata.SupportTimeMondaytoSaturday1000AMto500PMIST ? langdata.SupportTimeMondaytoSaturday1000AMto500PMIST : 'Support Time : Monday to Saturday | 10:00 AM to 5:00 PM (IST)' }
                                            &nbsp;<Tag style={{
                                                color : 'rgb(255, 255, 255)',
                                                backgroundColor : 'rgba(235, 22, 22, 0)',
                                                marginBottom : '5px'
                
                                            }} > {langdata.AlltimesdisplayedareinIndianStandardTimeISTonly ? langdata.AlltimesdisplayedareinIndianStandardTimeISTonly : 'All times displayed are in Indian Standard Time (IST) only'}</Tag>
                                        </div>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col
                                        xs={{ span: 24 }}
                                        lg={{ span: 0 }}
                                        style={{
                                            marginBottom: '0px',
                                            background: '#cc0a1d',
                                            color: '#fff',
                                            fontSize: '12px',
                                            paddingTop: '5px',
                                            paddingBottom: '10px',
                                            fontFamily: 'Roboto',
                                            fontWeight: '500',
                                        }}
                                    >
                                        <Col
                                        // onClick={this.onClickDevice}
                                            style={{ textAlign: 'center' }}
                                            xs={{ span: 24, offset: 0 }}
                                            md={{ span: 24, offset: 0 }}
                                        >
                                            {langdata.ForbetteruserexperienceDownloadthemobileappnow ? langdata.ForbetteruserexperienceDownloadthemobileappnow : 'For better user experience, Download the mobile app now!' }
                                            <br />
                                            {langdata.SupportTimeMondaytoSaturday ? langdata.SupportTimeMondaytoSaturday : 'Support Time : Monday to Saturday'}
                                            <br />
                                            {langdata.T1000AMto500PMIST ? langdata.T1000AMto500PMIST : '10:00 AM to 5:00 PM (IST)'}
                                            <br/>
                                            <Tag style={{
                                                color : 'rgb(255, 255, 255)',
                                                backgroundColor : 'rgba(235, 22, 22, 0)',
                                                marginBottom : '5px'
                
                                            }} > {langdata.AlltimesdisplayedareinIndianStandardTimeISTonly ? langdata.AlltimesdisplayedareinIndianStandardTimeISTonly : 'All times displayed are in Indian Standard Time (IST) only'}</Tag>
                                        </Col>
                                    </Col>
                                </Row>
                            </div>
                            <Outlet />
                        </Content>

                    </Layout>
                    <CommonFooter />
                </Layout>

                {/* Confirm Logout  Modal Starts */}
                <Modal title="Confirm logout" open={openConfirmLogout} onOk={confirmLogout} onCancel={cancelLogout}>
                    <Row style={{
                        marginTop: '10px',
                        marginBottom: '10px',
                        background: '#FFFFFF',
                        alignItems: 'center'
                    }} >
                        <Col span={24}>
            Are you sure you want to logout of the system?
                        </Col>
                    </Row>
                </Modal>
                {/* Confirm Logout  Modal Ends */}
            </CommonContextProvider>
        </>

    );
};

export default App;